/**
 * Stores a value in localStorage with an expiry timestamp.
 * @param {string} key
 * @param {*} value
 * @param {number} ttl - time to live in milliseconds
 */
export function setWithExpiry(key, value, ttl) {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

/**
 * Retrieves a value from localStorage, returning null if expired or missing.
 * @param {string} key
 * @returns {*|null}
 */
export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}
